// Sans serif
import "@fontsource/raleway/300.css";
import "@fontsource/raleway/400.css";
import "@fontsource/raleway/600.css";
import "@fontsource/raleway/700.css";

// Monospace
import "@fontsource/source-code-pro/400.css";
import "@fontsource/source-code-pro/500.css";

// Font Awesome
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faFacebookSquare,
    faGithub,
    faLaravel,
    faVuejs
} from '@fortawesome/free-brands-svg-icons';
import {
} from '@fortawesome/free-regular-svg-icons';
import {
    faArrowTurnUp,
    faArrowUp,
    faBan,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faCheck,
    faCircle,
    faCodePullRequest,
    faCog,
    faCopy,
    faEdit,
    faEllipsisH,
    faEnvelope,
    faEye,
    faEyeSlash,
    faIdBadge,
    faInfoCircle,
    faLanguage,
    faMinus,
    faMobileAlt,
    faPaperPlane,
    faPlus,
    faQuestionCircle,
    faSave,
    faShieldAlt,
    faSignOutAlt,
    faSlidersH,
    faSpinner,
    faStairs,
    faStar,
    faSyncAlt,
    faTimes,
    faTrash,
    faUndo,
    faUnlockAlt,
    faUpload,
    faUser,
    faUserCheck,
    faUserCog,
    faUsers,
    faUserTimes,
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faArrowTurnUp,
    faArrowUp,
    faBan,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faCheck,
    faCircle,
    faCodePullRequest,
    faCog,
    faCopy,
    faEdit,
    faEllipsisH,
    faEnvelope,
    faEye,
    faEyeSlash,
    faFacebookSquare,
    faGithub,
    faIdBadge,
    faInfoCircle,
    faLanguage,
    faLaravel,
    faMinus,
    faMobileAlt,
    faPaperPlane,
    faPlus,
    faQuestionCircle,
    faSave,
    faShieldAlt,
    faSignOutAlt,
    faSlidersH,
    faSpinner,
    faStairs,
    faStar,
    faSyncAlt,
    faTimes,
    faTrash,
    faUndo,
    faUnlockAlt,
    faUpload,
    faUserCheck,
    faUserCog,
    faUser,
    faUsers,
    faUserTimes,
    faVuejs
)
dom.watch();
